import "./AboutWhyUs.module.css";
import Header from "@/reusable_sections/Header";
import CompanyStory from "./sections/CompanyStory";
import LeadershipTeam from "./sections/LeadershipTeam";
import SafetyESGCommitment from "./sections/SafetyESGCommitment";
import Footer from "@/reusable_sections/Footer";
export default function AboutWhyUsPage() {
  return <div>
      <Header />
      <CompanyStory />
      <LeadershipTeam />
      <SafetyESGCommitment />
      <Footer />
    </div>;
}